<template lang="pug">
  label.radio-label(@click.stop="")
    .mr-radio(:class="{ selected: shouldBeChecked, disabled: disabled, 'large-purple': largeAndPurple, 'bullseye': bullseye }")
      input(type="radio" :id="id" :name="name" :checked="shouldBeChecked" :value="value" @change="updateInput" @click="emitClick" :disabled="disabled")
    slot
</template>

<script>
  export default {
    name: "mrRadio",

    props: {
      id: {
        type:String
      },
      name: {
        type: String
      },
      value: {
      },
      modelValue: {
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      largeAndPurple: {
        type: Boolean,
        default: false
      },
      bullseye: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:modelValue', 'click'],

    computed: {
      shouldBeChecked() {
        return this.modelValue == this.value;
      }
    },

    methods: {
      updateInput() {
        this.$emit('update:modelValue', this.value);
      },

      emitClick() {
        this.$emit('click', this.value);
      }
    }
  };
</script>

<style scoped lang="stylus">
  .radio-label
    .mr-radio
      margin-right 0.5em
      transform scale(1.2)
      
    .large-purple
      &.selected
        border-color cta-color-1

      &.selected:before
        background-color cta-color-1
        border cta-color-1
        transform scale(1.3)
        top 4px
        left 4px

    .bullseye
      margin-right 0
      border-color brand-color-1
      &.selected
        border 7px solid brand-color-1
        color #fff
      &.selected:before
        display none

</style>